import { UploadFile } from "@king-ict/eupisi-ui/models";

import { MedicalExamination } from "../../../models/Request";
import { Attachment } from "../../../models/Shared/Attachment";

export const appendToExistingExam =
  (exam: MedicalExamination) =>
  (arr: UploadFile[] | Attachment[], key: keyof MedicalExamination) => {
    return {
      ...exam,
      [key]: arr.length ? arr : undefined,
    };
  };
